import { render, staticRenderFns } from "./workbench_.vue?vue&type=template&id=9c1a46c4&scoped=true"
import script from "./workbench_.vue?vue&type=script&lang=js"
export * from "./workbench_.vue?vue&type=script&lang=js"
import style0 from "./workbench_.vue?vue&type=style&index=0&id=9c1a46c4&prod&lang=less&scoped=true"
import style1 from "./workbench_.vue?vue&type=style&index=1&id=9c1a46c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1a46c4",
  null
  
)

export default component.exports